import { useMutation } from "@tanstack/react-query";
import api from '../../services/api';

export const useNottificationSend = () => {
  return useMutation({
    mutationFn: async (body) => {
      const isFormData = body instanceof FormData;
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
      const res = await api.post("/send-nottification", body, config);
      return res;
    }
  })
}